module.exports = "<seeya-import-game></seeya-import-game>\r\n\r\n<seeya-game-runner></seeya-game-runner>"


//////////////////
// WEBPACK FOOTER
// C:/Repos/seeya/src/app/runner/runner.component.html
// module id = ../../../../../src/app/runner/runner.component.html
// module chunks = main